import {memo} from 'react';

import styled, {css} from 'styled-components';
import {isEmpty, noop} from 'lodash';

import {flipOnLTR} from '~/shared/theme/flipOnLTR';

import {
  DropdownButtonContainer,
  DropdownButtonTitle,
  StartIconWrap,
  DropdownArrow,
  DropdownArrowBold,
} from './styled.components';

const dropdownButtonArrowStyles = css`
  ${flipOnLTR`
    margin-right: 4px;
  `}
`;

const StyledDropdownArrowBold = styled(DropdownArrowBold)`
  min-width: 14px;
  ${dropdownButtonArrowStyles}
`;

const StyledDropdownArrow = styled(DropdownArrow)`
  min-width: 14px;
  ${dropdownButtonArrowStyles}
`;

const DropdownButton = ({
  testId = 'dropdownBtn',
  showArrow = true,
  setDropdownBtnRef = noop,
  buttonTitle,
  btnAriaLabel,
  btnId,
  isOpen,
  onDropdownClick,
  startIcon,
  isMaxLargeMobile,
}) => {
  const arrow = (() => (!isMaxLargeMobile ?
      (<StyledDropdownArrow $isOpen={isOpen}/>) :
      (<StyledDropdownArrowBold $isOpen={isOpen} />))
  )();

  return (
    <DropdownButtonContainer
      data-test-id={testId}
      ref={setDropdownBtnRef}
      onClick={onDropdownClick}
      aria-controls={btnId}
      aria-label={btnAriaLabel}
      hideStartIcon={isEmpty(startIcon)}
      isOpen={isOpen}
      isExpendable
    >
      {startIcon && <StartIconWrap>{startIcon}</StartIconWrap>}

      {
        buttonTitle && typeof buttonTitle !== 'string' ? buttonTitle : (
          <DropdownButtonTitle>
            {buttonTitle}
          </DropdownButtonTitle>
        )
      }

      {showArrow && arrow}
    </DropdownButtonContainer>
  );
};

export default memo(DropdownButton);
